
import apiClient from '../helpers/apiClient';
import { authHeader } from '../helpers/authHeader';


export const moduleListService = {
     getModuleList,
     createOrUpdateModule,
     getParentMenuList,
     getModuleDetails,
     getParentMenuListForSingleModule,
     getChildMenuList,
     saveChildMenu,
     getChildMenuDetails,
     saveParentMenu
    
};





async function  getModuleList() {
    return  apiClient.get(`/module/module-list`, authHeader());
}



async function  getParentMenuList() {
    return  apiClient.get(`/module/parent-menu-list`, authHeader());
}


async function  getModuleDetails(id) {
    return  apiClient.get(`/module/module-details/${id}`, authHeader());
}

async function  getParentMenuListForSingleModule(id) {
    return  apiClient.get(`/module/parent-menu-list-for-single-module/${id}`, authHeader());
}


async function  saveParentMenu(data) {
    return  apiClient.post(`/module/save-parent-menu`, data, authHeader());
}



async function  createOrUpdateModule(data) {
    return  apiClient.post(`/module/create-or-update-module`, data, authHeader());
}


async function  getChildMenuList() {
    return  apiClient.get(`/module/child-menu-list`, authHeader());
}


async function  saveChildMenu(data) {
    return  apiClient.post(`/module/save-child-menu`, data, authHeader());
}

async function  getChildMenuDetails(id) {
    return  apiClient.get(`/module/child-menu-details/${id}`, authHeader());
}








